import React, { useState, useEffect, useContext} from "react";
import Context from "../../../context/context";
import Swal  from "sweetalert2";
import Modal from "react-modal";
import Web3 from "web3";
import UFOpTGCContract from '../abi/Ptgc.json';
import UFOHEXContract from '../abi/Hex.json';
import UFOHEXETHContract from '../abi/HexEth.json';
import UFOINCContract from '../abi/Inc.json';
import UFOPLSXContract from '../abi/Plsx.json';
import UFOPLSContract from '../abi/Pls.json';
import UFODAIContract from '../abi/Dai.json';
import UFOContract from '../abi/Ufo.json';
import StakingContract from '../abi/Staking.json';
import ERC20Contract from '../abi/Erc20.json';
import { formatUnits, parseUnits } from "ethers";
import { providerURL, txAfterDone, txDone, txStart } from '../../../helper/Helper';

const AddLiquidityModal = ({ modalIsOpen, closeModal, pair, updatePage}) => {
  const {account, onConnect, providers} = useContext(Context);
  
  const [pairAddrees, setPairAddrees] = useState(0);
  const [pairBalance, setPairBalance] = useState(0);
  const [pairSupply, setPairSupply] = useState(0);
  const [token0Contract, setToken0Contract] = useState(0);
  const [token1Contract, setToken1Contract] = useState(0);
  const [token0Name, setToken0Name] = useState('pTGC');
  const [token1Name, setToken1Name] = useState('UFO');
  const [token0Balance, setToken0Balance] = useState(0);
  const [token1Balance, setToken1Balance] = useState(0);
  const [token0Share, setToken0Share] = useState(0);
  const [token1Share, setToken1Share] = useState(0);
  const [token0Amount, setToken0Amount] = useState('');
  const [token1Amount, setToken1Amount] = useState('');
  const [token0Approval, setToken0Approval] = useState(0);
  const [token1Approval, setToken1Approval] = useState(0);
  const [tokenAContract, setTokenAContract] = useState(0);
  const [tokenBContract, setTokenBContract] = useState(0);

  useEffect(() => {
    setToken1Amount(toFixed(Number(token1Amount), 2));
  }, [token1Amount]);

  useEffect(() => {
    setToken0Amount(toFixed(Number(token0Amount), 2));
  }, [token0Amount]);

  const handleModalOpen = async () => {
    await getData();
  }; 

  const getData = async () => {
      const web3 = await new Web3(providers);

      const newPair = await pair.split("_");
      await setToken0Name(newPair[1]);
      await setToken1Name(newPair[0]);

      await setToken0Balance(0);
      await setToken1Balance(0);
      await setToken0Approval(0);
      await setToken1Approval(0);
      await setToken0Amount('');
      await setToken1Amount('');

      let pairInstance;
      let pairAddress;
      if (pair == "UFO_PTGC") {
          pairInstance = await new web3.eth.Contract(UFOpTGCContract.ABI, UFOpTGCContract.Contract);
          await setPairAddrees(UFOpTGCContract.Contract);
      } else if (pair == "UFO_HEX") {
          pairInstance = await new web3.eth.Contract(UFOHEXContract.ABI, UFOHEXContract.Contract);
          await setPairAddrees(UFOHEXContract.Contract);
      } else if (pair == "UFO_HEXETH") {
          pairInstance = await new web3.eth.Contract(UFOHEXETHContract.ABI, UFOHEXETHContract.Contract);
          await setPairAddrees(UFOHEXETHContract.Contract);
      } else if (pair == "UFO_INC") {
          pairInstance = await new web3.eth.Contract(UFOINCContract.ABI, UFOINCContract.Contract);
          await setPairAddrees(UFOINCContract.Contract);
      } else if (pair == "UFO_PLSX") {
          pairInstance = await new web3.eth.Contract(UFOPLSXContract.ABI, UFOPLSXContract.Contract);
          await setPairAddrees(UFOPLSXContract.Contract);
      } else if (pair == "UFO_PLS") {
          pairInstance = await new web3.eth.Contract(UFOPLSContract.ABI, UFOPLSContract.Contract);
          await setPairAddrees(UFOPLSContract.Contract);
      } else {
          pairInstance = await new web3.eth.Contract(UFODAIContract.ABI, UFODAIContract.Contract);
          await setPairAddrees(UFODAIContract.Contract);
      }

      await setPairSupply(toFixed(Number(formatUnits(await pairInstance.methods.totalSupply().call(), 18)), 8));
      await setPairBalance(toFixed(Number(formatUnits(await pairInstance.methods.balanceOf(account).call(), 18)), 8));

      let pairShare = await pairInstance.methods.getReserves().call();
      let token0 = await pairInstance.methods.token0().call();
      let token1 = await pairInstance.methods.token1().call();

      await setTokenAContract(token0);
      await setTokenBContract(token1);

      if (pair === "UFO_HEX" || pair === "UFO_HEXETH") {
          if (token0.toLowerCase() === UFOContract.Contract.toLowerCase()) {
              await setToken0Share(Number(formatUnits(pairShare._reserve1, 8)));
              await setToken1Share(Number(formatUnits(pairShare._reserve0, 18)));
          } else {
              await setToken0Share(Number(formatUnits(pairShare._reserve0, 8)));
              await setToken1Share(Number(formatUnits(pairShare._reserve1, 18)));
          }
      } else {
          if (token0.toLowerCase() === UFOContract.Contract.toLowerCase()) {
              await setToken0Share(Number(formatUnits(pairShare._reserve1, 18)));
              await setToken1Share(Number(formatUnits(pairShare._reserve0, 18)));
          } else {
              await setToken0Share(Number(formatUnits(pairShare._reserve0, 18)));
              await setToken1Share(Number(formatUnits(pairShare._reserve1, 18)));
          }
      }

      if (token0.toLowerCase() === UFOContract.Contract.toLowerCase()) {
          token0 = await pairInstance.methods.token1().call();
          token1 = await pairInstance.methods.token0().call();
      }

      await setToken0Contract(token0);
      await setToken1Contract(token1);

      let token0Instance = await new web3.eth.Contract(ERC20Contract.ABI, token0);
      let token1Instance = await new web3.eth.Contract(ERC20Contract.ABI, token1);

      await setToken1Approval(Number(formatUnits(await token1Instance.methods.allowance(account, UFOContract.Contract).call(), 18)));
      await setToken1Balance(toFixed(Number(formatUnits(await token1Instance.methods.balanceOf(account).call(), 18)), 2));

      console.log("pair =>", pair);

      if (pair === "UFO_HEX" || pair === "UFO_HEXETH") {
          await setToken0Balance(toFixed(Number(formatUnits(await token0Instance.methods.balanceOf(account).call(), 8)), 2));
          await setToken0Approval(Number(formatUnits(await token0Instance.methods.allowance(account, UFOContract.Contract).call(), 8)));
      } else if (pair === "UFO_PLS") {
          await setToken0Balance(toFixed(Number(formatUnits(await web3.eth.getBalance(account), 18)), 2));
          await setToken0Approval(Number(formatUnits(await token0Instance.methods.allowance(account, UFOContract.Contract).call(), 18)));
      } else {
          await setToken0Balance(toFixed(Number(formatUnits(await token0Instance.methods.balanceOf(account).call(), 18)), 2));
          await setToken0Approval(Number(formatUnits(await token0Instance.methods.allowance(account, UFOContract.Contract).call(), 18)));
      }
  }
  
  const approveTokens = async (token, amountToAdd) => {
      const web3 = await new Web3(providers);
      const tokenContract = new web3.eth.Contract(ERC20Contract.ABI, token);
      const amount = parseUnits(String(amountToAdd || "0"), 18);

      try {
          await tokenContract.methods.approve(UFOContract.Contract, amount).send({
              from: account
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                title: "Error Found",
                text: error.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Close",
                customClass: {
                  confirmButton: "btn-danger"
                }
              });
          }).then(function(receipt) {
              txDone()
              setTimeout(() => {
                  txAfterDone()
              }, 2000)
              getData();
          });
      } catch (error) {
          Swal.fire({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Close",
            customClass: {
              confirmButton: "btn-danger"
            }
          });
      }
  }

  const addLiquidity = async () => {
      const web3 = await new Web3(providers);
      const tokenContract = new web3.eth.Contract(UFOContract.ABI, UFOContract.Contract);
      const token0 = pair === "UFO_HEX" || pair === "UFO_HEXETH" ? toPlainString(token0Amount * 10 ** 8) : toPlainString(token0Amount * 10 ** 18);
      const token1 = toPlainString(token1Amount * 10 ** 18);
      
      try {
          if (pair === "UFO_PLS") {
              await tokenContract.methods.addLiquidityETH(token1).send({
                  from: account,
                  value: token0
              }).on('transactionHash', function(payload) {
                  closeModal();
                  txStart();
              }).on('error', function(error) {
                  Swal.fire({
                    title: "Error Found",
                    text: error.message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonText: "Close",
                    customClass: {
                      confirmButton: "btn-danger"
                    }
                  });
              }).then(function(receipt) {
                  txDone()
                  setTimeout(() => {
                      txAfterDone()
                  }, 2000)
                  updatePage()
              });
          } else {
              if (tokenAContract.toLowerCase() === UFOContract.Contract.toLowerCase()) {
                  await tokenContract.methods.addLiquidity(pairAddrees, token1, token0).send({
                      from: account
                  }).on('transactionHash', function(payload) {
                      closeModal();
                      txStart();
                  }).on('error', function(error) {
                      Swal.fire({
                        title: "Error Found",
                        text: error.message,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonText: "Close",
                        customClass: {
                          confirmButton: "btn-danger"
                        }
                      });
                  }).then(function(receipt) {
                      txDone()
                      setTimeout(() => {
                          txAfterDone()
                      }, 2000)
                      updatePage()
                  });
              } else {
                  await tokenContract.methods.addLiquidity(pairAddrees, token0, token1).send({
                      from: account
                  }).on('transactionHash', function(payload) {
                      closeModal();
                      txStart();
                  }).on('error', function(error) {
                      Swal.fire({
                        title: "Error Found",
                        text: error.message,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonText: "Close",
                        customClass: {
                          confirmButton: "btn-danger"
                        }
                      });
                  }).then(function(receipt) {
                      txDone()
                      setTimeout(() => {
                          txAfterDone()
                      }, 2000)
                      updatePage()
                  });
              }
          }
      } catch (error) {
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
        });
      }
  }

  function toPlainString(num) {
    return (''+ +num).replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/,
      function(a,b,c,d,e) {
        return e < 0
          ? b + '0.' + Array(1-e-c.length).join(0) + c + d
          : b + c + d + Array(e-d.length+1).join(0);
      });
  }

  function toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  }
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="UFOSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="good_times goldFont mb-0 mt-2  w-100">Add Liquidity</h2>
              <span className="fInter d-flex justify-content-center align-items-center mt-2 mb-2">Note: When you add liquidity, you will receive pool tokens representing your position.<br/>These tokens automatically earn fees proportional to your share of the pool, and can be redeemed at any time.</span>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-8 col-md-6 col-lg-6">
                  <div className="">
                  <div className="bSRIN overHide p-2">
                  <div className="bSRIN overHide mt-0 w-100" style={{background: 'rgb(26 26 26 / 90%)'}} >
                    <div className="amountSTaking d-flex justify-content-between align-items-center gap-3" >
                      <div className="d-flex gap-2 w-100">
                        <img className="img-fluid" src={"./images/"+token1Name+".png"} />
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder={`Please enter ${token1Name} amount`}
                          value={
                            token1Amount === "" || isNaN(Number(token1Amount.toString().replace(/,/g, "")))
                              ? ""
                              : Number(token1Amount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                })
                          }
                          onChange={async (e) => {
                            let raw = e.target.value.replace(/,/g, "");

                            if (raw === "") {
                              await setToken1Amount("");
                              await setToken0Amount("");
                              return;
                            }

                            if (!/^\d*(\.\d{0,2})?$/.test(raw)) return;

                            await setToken1Amount(raw);

                            const num = parseFloat(raw);
                            if (pairSupply > 0 && !Number.isNaN(num)) {
                              const token0Val = ((token0Share / token1Share) * num).toFixed(2);
                              await setToken0Amount(token0Val);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="snPortal" style={{ borderBottom: '0px' }}>
                      <div className="d-flex justify-content-between flex-wrap align-items-center">
                        <div>
                          <span className="fInter">Balance</span>
                          <h3 className="dollorValue value mt-0">
                            <span className="val">{parseFloat(token1Balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                        <div className="someBtns">
                          <button
                            className="someSnbtn"
                            onClick={async () => {
                              const num = Number(token1Balance) || 0;
                              const formatted = num.toFixed(2);
                              await setToken1Amount(formatted);

                              if (pairSupply > 0 && num > 0) {
                                const token0Val = ((token0Share / token1Share) * num).toFixed(2);
                                await setToken0Amount(token0Val);
                              }
                            }}
                            style={{ marginLeft: "8px" }} >
                            <span>Max</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="iconiconSR text-center m-auto mt-3 mb-3 "><img className="img-fluid" src="./images/PlusCircle.svg"/></div>
                  <div className="bSRIN overHide mt-3  w-100" style={{background: 'rgb(26 26 26 / 90%)'}} >
                    <div className="amountSTaking d-flex justify-content-between align-items-center gap-3" >
                      <div className="d-flex gap-2 w-100">
                        <img className="img-fluid" src={"./images/"+token0Name+".png"}/>
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder={`Please enter ${token0Name} amount`}
                          value={
                            token0Amount === "" || isNaN(Number(token0Amount.toString().replace(/,/g, "")))
                              ? ""
                              : Number(token0Amount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                })
                          }
                          onChange={async (e) => {
                            const raw = e.target.value.replace(/,/g, "");

                            if (raw === "") {
                              await setToken1Amount("");
                              await setToken0Amount("");
                              return;
                            }

                            if (!/^\d*(\.\d{0,2})?$/.test(raw)) return;

                            await setToken0Amount(raw);

                            if (pairSupply > 0 && !isNaN(parseFloat(raw))) {
                              const token1Val = ((token1Share / token0Share) * parseFloat(raw)).toFixed(2);
                              await setToken1Amount(token1Val);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="snPortal">
                      <div className="d-flex justify-content-between flex-wrap align-items-center">
                        <div>
                          <span className="fInter">Balance</span>
                          <h3 className="dollorValue value mt-0">
                            <span className="val">{parseFloat(token0Balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                        <div className="someBtns">
                          <button
                            className="someSnbtn"
                            onClick={async () => {
                              const num = Number(token0Balance) || 0;
                              const formatted = num.toFixed(2);
                              await setToken0Amount(formatted);

                              if (pairSupply > 0 && num > 0) {
                                const token1Val = ((token1Share / token0Share) * num).toFixed(2);
                                await setToken1Amount(token1Val);
                              }
                            }}
                            style={{ marginLeft: "8px" }} >
                            <span>Max</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    pairSupply > 0 ?
                    <>
                    <div className="mt-4">
                     <span className="fInter text-center w-100 d-block">Prices</span>
                      <div className=" mt-2" style={{borderTop: '1px solid #383835'}}>
                        <div className="borderBottom">
                          <div className="row m-0">
                            <div className="col-md-6 borderRight p-0">
                              <div className="snPortal">
                                <div className="">
                                  <h3 className="dollorValue value  mt-0 p-0">
                                    <span className="val">{token1Share > 0 ? parseFloat(token0Share / token1Share).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}</span>
                                  </h3>
                                  <span className='fInter'>{token0Name} per {token1Name}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 p-0">
                              <div className="snPortal">
                                <div className="">
                                  <h3 className="dollorValue value  mt-0 p-0">
                                    <span className="val">{token0Share > 0 ? parseFloat(token1Share / token0Share).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}</span>
                                  </h3>
                                  <span className='fInter'>{token1Name} per {token0Name}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </>
                    :
                    <>
                    </>
                  }
                  
                  <div className="someBtns SRTOP  d-flex gap-2 mt-2 p-2">
                    {
                     Number(token0Amount) > Number(token0Balance) ?
                     <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" disabled>
                          <span className="d-flex align-items-center w-100 justify-content-between">Insufficient {token0Name} Balance <div className="iconSR"><img className="img-fluid" src="./images/PlusCircle.svg" /></div></span>
                        </button>
                     </>
                     :
                     Number(token1Amount) > Number(token1Balance) ?
                     <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" disabled>
                          <span className="d-flex align-items-center w-100 justify-content-between">Insufficient {token1Name} Balance <div className="iconSR"><img className="img-fluid" src="./images/PlusCircle.svg" /></div></span>
                        </button>
                     </>
                     :
                     Number(token0Amount) > Number(token0Approval) && pair !=="UFO_PLS"?
                     <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" onClick={() => {approveTokens(token0Contract, token0Amount)}}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Approve {token0Name} <div className="iconSR"><img className="img-fluid" src="./images/PlusCircle.svg" /></div></span>
                        </button>
                     </>
                     :
                     Number(token1Amount) > Number(token1Approval) ?
                     <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" onClick={() => {approveTokens(token1Contract, token1Amount)}}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Approve {token1Name} <div className="iconSR"><img className="img-fluid" src="./images/PlusCircle.svg" /></div></span>
                        </button>
                     </>
                     :
                     <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" onClick={() => {addLiquidity()}} disabled={token0Amount > 0 && token1Amount > 0 ? '' : 'disabled'}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Add New Liquidity <div className="iconSR"><img className="img-fluid" src="./images/PlusCircle.svg" /></div></span>
                        </button>
                     </>
                    }
                  </div>
                  {
                    pairSupply > 0 && pairBalance > 0 ?
                    <>
                      <div className="subcontent SRTOP p-3 mt-3">
                      <div className="relative">
                        <div className=" d-flex align-items-center justify-content-between flex-wrap gap-1">
                          <h2 className="speacialH2 d-flex align-items-center">
                            <span className="d-flex bothCoins">
                              <img className="img-fluid" src={"./images/"+token1Name+".png"}/>
                              <img className="img-fluid" src={"./images/"+token0Name+".png"}/>
                            </span>
                            {token0Name} / {token1Name}
                          </h2>
                          <h2 className="speacialH2">
                            {parseFloat(pairBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PLP
                          </h2>
                        </div>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Your Pool Share</span>
                        <p className="m-0">
                          <span className="">{parseFloat((pairBalance / pairSupply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%</span>
                        </p>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Pooled {token0Name}</span>
                        <p className="m-0">
                          <span className="">{parseFloat((((pairBalance / pairSupply) * 100) * token0Share) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </p>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Pooled {token1Name}</span>
                        <p className="m-0">
                          <span className="">{parseFloat((((pairBalance / pairSupply) * 100) * token1Share) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </p>
                      </div>
                    </div>
                    </>
                    :
                    <>
                    </>
                  }
                 </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </Modal>
    </>
  );
};

export default AddLiquidityModal;